import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { PageTree } from "./page-tree";
import { PageTreeNodeData } from "./page-tree";

export interface AgileHubSideNavProps {
    nodes: PageTreeNodeData[];
}

export const AgileHubSideNav = ({ nodes }: AgileHubSideNavProps) => {
    const headerCss = css({
        fontSize: ".875rem",
        fontWeight: "700",
        color: "#42526e",
        marginBlockStart: 0,
        marginBlockEnd: "14px",
        lineHeight: "1.25",
        textTransform: "uppercase",
        letterSpacing: "1px",
        fontFamily:
            "Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif !important"
    });

    const agileSideNavCss = css({
        width: "100%",
        maxHeight: "calc(100vh - 150px)",
        overflow: "auto",
        position: "sticky",
        insetBlockStart: "76px",
        insetBlockEnd: "auto",
        display: "none",

        [media.above.sm]: {
            display: "block",
            gridColumnStart: "1",
            gridColumnEnd: "4"
        }
    });

    return (
        <div css={agileSideNavCss} className="agile-sidenav">
            <h5 css={headerCss}>
                <FormattedMessage
                    id="agile-overview-sidenav.browse-topics"
                    defaultMessage="Browse Topics"
                />
            </h5>
            <PageTree nodes={nodes} />
        </div>
    );
};
